export default __webpack_public_path__ + "static/media/cc_3.aa23f13c.mp3";